import { HostEditActionDefinition } from '@wix/editor-platform-host-integration-apis';

import { filterByTags, isObjectEmpty } from '../utils';
import { PlatformContext } from '../types';
import {
  deriveDefaultEditActionsFromManifest,
  getResolvedHostEditActions,
  getResolvedPlatformEditActions,
  customizeNativeActions,
} from './index';
import { groupNativeActions } from './groupNativeActions';
import { filterActionsByDataBindingOverrides } from '../dataBindingOverrides';

function getNativeEditActions(
  platformContext: PlatformContext,
  tags?: string[],
): HostEditActionDefinition[] {
  const { componentsAPI, editorPointer } = platformContext;

  const derivedEditActions = deriveDefaultEditActionsFromManifest(
    componentsAPI,
    editorPointer,
  );
  const nativeActions = componentsAPI.get.editActions(editorPointer);

  if (isObjectEmpty(nativeActions) && isObjectEmpty(derivedEditActions)) {
    return [];
  }

  const filteredManifestActions =
    platformContext.componentsAPI.editActions.applyDisplayFilters(
      editorPointer,
      {
        ...derivedEditActions,
        ...nativeActions,
      },
    );

  const filteredActions = filterActionsByDataBindingOverrides(
    filteredManifestActions,
    platformContext,
  );

  const groupedNativeActions = groupNativeActions(filteredActions);

  const resolvedNativeEditActions = [
    ...getResolvedHostEditActions<HostEditActionDefinition>(
      groupedNativeActions.nativeActions,
      platformContext,
    ),
    ...getResolvedPlatformEditActions<HostEditActionDefinition>(
      groupedNativeActions.platformNativeActions,
      platformContext,
    ),
  ];

  const resolvedCustomizedNativeEditActions = Object.values(
    customizeNativeActions(
      groupedNativeActions.customizedNativeActions,
      platformContext,
    ),
  );

  return filterByTags<HostEditActionDefinition>(
    [...resolvedNativeEditActions, ...resolvedCustomizedNativeEditActions],
    tags,
  );
}

export { getNativeEditActions };
